enum CmsContentEndpoints {
  getBanners = 'bin/registration-form/getBanners',
}

export default CmsContentEndpoints;
